import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "content"]
  static values = {
    url: String,
    interval: { type: Number, default: 4000 }
  }

  connect() {
    this.elapsedSeconds = 0
    this.poll()
  }

  disconnect() {
    this.stopPolling()
    this.stopTimer()
  }

  poll() {
    this.pollTimer = setInterval(() => {
      this.checkJobStatus()
    }, this.intervalValue)

    // Check immediately on connect
    this.checkJobStatus()
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
    }
  }

  async checkJobStatus() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (data.error) {
          this.showError(`Ошибка генерации страницы: ${data.error}`)
          this.hideSpinner()
          this.stopPolling()
        } else if (data.completed == true) {
          this.hideSpinner()
          this.showContent()
          this.stopPolling()
        } else {
          this.showSpinner()
          this.hideContent()
        }
      }
    } catch (error) {
      console.error('Error checking job status:', error)
    }
  }

  startTimer() {
    // Only start timer if it's not already running
    if (!this.timerInterval) {
      this.elapsedSeconds = 0
      this.updateTimerDisplay()
      this.timerInterval = setInterval(() => {
        this.elapsedSeconds++
        this.updateTimerDisplay()
      }, 1000)
    }
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
      this.timerInterval = null
    }
  }

  updateTimerDisplay() {
    if (this.hasSpinnerTarget) {
      // Find or create timer element within spinner
      let timerElement = this.spinnerTarget.querySelector('.timer-display')
      if (!timerElement) {
        timerElement = document.createElement('div')
        timerElement.className = 'timer-display'
        timerElement.style.cssText = 'top: 100px; left: 250px; transform: translate(-50%, -50%); font-weight: bold; color: #333;'
        this.spinnerTarget.style.position = 'relative'
        this.spinnerTarget.appendChild(timerElement)
      }
      timerElement.textContent = `${this.elapsedSeconds} секунд`
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none')
      this.startTimer()
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('d-none')
      this.stopTimer()
    }
  }

  showContent() {
    console.log('Showing content')

    window.location.reload()
    // if (this.hasContentTarget) {
    //   this.contentTarget.classList.remove('d-none')
    // }
  }

  showToaster(message, type = 'success', duration = 3000) {
    let toasterContainer = document.getElementById('toaster-container');
    if (!toasterContainer) {
      toasterContainer = document.createElement('div');
      toasterContainer.id = 'toaster-container';
      toasterContainer.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        display: flex;
        flex-direction: column;
        gap: 10px;
      `;
      document.body.appendChild(toasterContainer);
    }

    const toaster = document.createElement('div');
    toaster.textContent = message;

    const backgroundColor = type === 'error' ? '#dc3545' : '#28a745';
    toaster.style.cssText = `
      background-color: ${backgroundColor};
      color: white;
      padding: 12px 16px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      min-width: 250px;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      font-size: 14px;
    `;

    toasterContainer.appendChild(toaster);

    // Animate in
    setTimeout(() => {
      toaster.style.transform = 'translateX(0)';
    }, 10);

    // Animate out and remove
    setTimeout(() => {
      toaster.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (toaster.parentNode) {
          toaster.parentNode.removeChild(toaster);
        }
      }, 300);
    }, duration);
  }

  showError(message) {
    console.log('Showing error:', message)
    this.showToaster(message, 'error')
  }

  hideContent() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('d-none')
    }
  }
}
